export default __webpack_public_path__ + "static/media/img-0376-switzerland-full-face.6ca5892c.png";